(() => {
  const money = (cents, currency = 'USD') => new Intl.NumberFormat(undefined, {
    style: 'currency', currency, maximumFractionDigits: cents % 100 ? 2 : 0
  }).format(cents / 100);
  const panelDimensions = { width: 9.84, height: 9.84 };

  function initBuyBox(root) {
    if (root.dataset.aclReady) return;
    root.dataset.aclReady = 'true';
    const data = JSON.parse(root.querySelector('[data-acl-product-json]')?.textContent || '{"variants":[]}');
    const currency = root.dataset.currency || 'USD';
    const variant = (data.variants || []).find(item => item.available !== false) || data.variants?.[0];
    if (!variant) return;

    const widthInput = root.querySelector('[data-acl-width]');
    const heightInput = root.querySelector('[data-acl-height]');
    const mainAtc = root.querySelector('[data-acl-atc]');
    const stickyAtc = root.querySelector('[data-acl-sticky-atc]');
    let current = null;
    let selectedLocation = '';
    let taughtMeasurements = false;
    const setText = (selector, value) => {
      const element = root.querySelector(selector);
      if (element) element.textContent = value;
    };

    const setStep = (name, open) => {
      const step = root.querySelector(`[data-acl-config-step="${name}"]`);
      const trigger = root.querySelector(`[data-acl-step-trigger="${name}"]`);
      const panel = root.querySelector(`[data-acl-step-panel="${name}"]`);
      if (!step || !trigger || !panel) return;
      step.classList.toggle('is-open', open);
      trigger.setAttribute('aria-expanded', String(open));
      panel.hidden = !open;
      if (open) {
        panel.classList.remove('is-opening');
        requestAnimationFrame(() => panel.classList.add('is-opening'));
      }
    };

    const teachMeasurements = () => {
      if (taughtMeasurements) return;
      taughtMeasurements = true;
      const step = root.querySelector('[data-acl-config-step="measure"]');
      step?.classList.add('is-teaching-measure');
      setTimeout(() => step?.classList.remove('is-teaching-measure'), 3300);
    };

    const flashRecommendation = () => {
      const recommendation = root.querySelector('[data-acl-recommendation]');
      recommendation?.classList.remove('is-updating');
      requestAnimationFrame(() => recommendation?.classList.add('is-updating'));
      setTimeout(() => recommendation?.classList.remove('is-updating'), 420);
    };

    const candidate = (requestedWidth, requestedHeight) => {
      const columns = Math.max(1, Math.round(requestedWidth / panelDimensions.width));
      const rows = Math.max(1, Math.round(requestedHeight / panelDimensions.height));
      const quantity = columns * rows;
      const total = variant.price * quantity;
      const compareAtPrice = Number(variant.compareAtPrice) || 0;
      const compareTotal = compareAtPrice > variant.price ? compareAtPrice * quantity : 0;
      const savings = compareTotal ? compareTotal - total : 0;
      return { variant, quantity, columns, rows, total, compareTotal, savings };
    };

    function recommend() {
      const requestedWidth = Math.max(1, Number(widthInput.value) || 1);
      const requestedHeight = Math.max(1, Number(heightInput.value) || 1);
      current = candidate(requestedWidth, requestedHeight);
      render(requestedWidth, requestedHeight);
    }

    function render(requestedWidth, requestedHeight = Math.max(1, Number(heightInput.value) || 1)) {
      const coveredWidth = current.columns * panelDimensions.width;
      const coveredHeight = current.rows * panelDimensions.height;
      const coverage = Math.min(100, Math.round((coveredWidth / requestedWidth) * 100));
      setText('[data-acl-quantity-label]', `${current.quantity} ${current.quantity === 1 ? 'curtain' : 'curtains'}`);
      setText('[data-acl-coverage-size]', `${coveredWidth.toFixed(1)}' × ${coveredHeight.toFixed(1)}'`);
      setText('[data-acl-coverage-percent]', `${coverage}%`);
      setText('[data-acl-recommendation-label]', 'Your best fit');
      const compare = root.querySelector('[data-acl-compare]');
      if (compare) {
        compare.textContent = current.compareTotal ? money(current.compareTotal, currency) : '';
        compare.hidden = !current.compareTotal;
      }
      setText('[data-acl-total]', money(current.total, currency));
      setText('[data-acl-atc-total]', money(current.total, currency));
      setText('[data-acl-sticky-total]', money(current.total, currency));
      setText('[data-acl-unit]', money(current.variant.price, currency));
      setText('[data-acl-save]', current.savings ? `Save ${money(current.savings, currency)}` : '');
      const quantityLabel = `${current.quantity} ${current.quantity === 1 ? 'curtain' : 'curtains'}`;
      setText('[data-acl-sticky-config]', selectedLocation ? `${selectedLocation} · ${quantityLabel}` : quantityLabel);
      const wallPanels = root.querySelector('[data-acl-wall-panels]');
      if (wallPanels) {
        const panels = Array.from(
          { length: Math.min(current.quantity, 12) },
          () => document.createElement('i')
        );
        wallPanels.replaceChildren(...panels);
        wallPanels.style.gridTemplateColumns = `repeat(${Math.min(current.columns, 6)}, minmax(0, 1fr))`;
      }
      setText('[data-acl-measure-summary]', `${requestedWidth}' × ${requestedHeight}'`);
      const ready = Boolean(selectedLocation);
      if (mainAtc) mainAtc.disabled = !ready;
      if (stickyAtc) stickyAtc.disabled = false;
      setText('[data-acl-atc-label]', ready ? 'Buy now' : 'Choose an area');
      setText('[data-acl-sticky-label]', ready ? 'Buy now' : 'Choose area');
      window.AllmerryCurtainConfig = {
        quantity: current.quantity, variantId: current.variant.id,
        total: current.total, coverage, width: coveredWidth, height: coveredHeight,
        location: selectedLocation
      };
      window.dispatchEvent(new CustomEvent('allmerry:curtain-config', { detail: window.AllmerryCurtainConfig }));
    }

    root.querySelectorAll('[data-acl-step-trigger]').forEach(trigger => trigger.addEventListener('click', () => {
      const name = trigger.dataset.aclStepTrigger;
      if (name === 'measure' && !selectedLocation) {
        setStep('location', true);
        root.querySelector('[data-acl-config-step="location"]')?.classList.add('is-locked-pulse');
        setTimeout(() => root.querySelector('[data-acl-config-step="location"]')?.classList.remove('is-locked-pulse'), 650);
        return;
      }
      const open = trigger.getAttribute('aria-expanded') !== 'true';
      setStep(name, open);
      if (open) setStep(name === 'location' ? 'measure' : 'location', false);
    }));

    root.querySelectorAll('[data-acl-step]').forEach(button => button.addEventListener('click', () => {
      const input = button.dataset.aclStep === 'width' ? widthInput : heightInput;
      input.value = Math.max(Number(input.min), Math.min(Number(input.max), (Number(input.value) || 0) + Number(button.dataset.delta)));
      recommend();
      flashRecommendation();
      const heightControl = root.querySelector('[data-acl-measure-control="height"]');
      if (button.dataset.aclStep === 'width') {
        heightControl?.classList.add('is-next');
        setTimeout(() => heightControl?.classList.remove('is-next'), 1100);
      } else heightControl?.classList.remove('is-next');
    }));
    [widthInput, heightInput].forEach(input => input.addEventListener('input', () => { recommend(); flashRecommendation(); }));
    root.querySelectorAll('[data-acl-location]').forEach(button => button.addEventListener('click', () => {
      root.querySelectorAll('[data-acl-location]').forEach(item => { item.classList.toggle('is-active', item === button); item.setAttribute('aria-pressed', item === button); });
      selectedLocation = button.dataset.aclLocationName || button.textContent.trim();
      root.classList.add('has-location');
      button.classList.add('is-confirming');
      setTimeout(() => button.classList.remove('is-confirming'), 520);
      setText('[data-acl-location-summary]', `✓ ${selectedLocation} selected`);
      setTimeout(() => {
        setStep('location', false);
        setStep('measure', true);
        teachMeasurements();
      }, 430);
      recommend();
    }));
    async function goToCheckout() {
      if (!current || !selectedLocation) {
        setStep('location', true);
        return false;
      }
      const shopRoot = window.Shopify?.routes?.root || '/';
      const buttons = root.querySelectorAll('[data-acl-atc], [data-acl-sticky-atc]');
      buttons.forEach(button => { button.disabled = true; button.classList.add('is-loading'); });
      try {
        const response = await fetch(`${shopRoot}cart/add.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(current.variant.id), quantity: current.quantity }] })
        });
        if (!response.ok) {
          const result = await response.json().catch(() => ({}));
          throw new Error(result.description || 'Could not add this curtain.');
        }
        window.location.assign('/checkout');
        return true;
      } catch (error) {
        const toast = root.querySelector('[data-acl-toast]');
        if (toast) {
          toast.textContent = error.message;
          toast.hidden = false;
          setTimeout(() => { toast.hidden = true; }, 3500);
        }
        buttons.forEach(button => { button.disabled = false; button.classList.remove('is-loading'); });
        return false;
      }
    }
    root.querySelector('[data-acl-atc]')?.addEventListener('click', goToCheckout);
    root.querySelector('[data-acl-sticky-atc]')?.addEventListener('click', goToCheckout);
    const sticky = root.querySelector('[data-acl-sticky]');
    if (sticky && mainAtc && 'IntersectionObserver' in window) new IntersectionObserver(([entry]) => {
      sticky.hidden = entry.isIntersecting;
      sticky.classList.toggle('is-visible', !entry.isIntersecting);
    }, { threshold: 0 }).observe(mainAtc);
    recommend();
  }

  function initPreview(root) {
    if (root.dataset.aclReady) return;
    root.dataset.aclReady = 'true';
    const fileInput = root.querySelector('[data-acl-file-input]');
    const cameraInput = root.querySelector('[data-acl-camera-input]');
    const upload = root.querySelector('[data-acl-upload-state]');
    const preview = root.querySelector('[data-acl-preview-state]');
    const before = root.querySelector('[data-acl-before-image]');
    const generated = root.querySelector('[data-acl-generated-image]');
    const overlay = root.querySelector('[data-acl-light-overlay]');
    let config = { quantity: 2 };
    let objectUrl = '';
    let hasGenerated = false;

    const setView = (view) => {
      const lights = view === 'lights' && hasGenerated;
      before.hidden = lights && !!generated?.src;
      if (generated) generated.hidden = !lights || !generated.src;
      overlay.hidden = !lights || !!generated?.src;
      root.querySelectorAll('[data-acl-preview-view]').forEach(button => { const active = button.dataset.aclPreviewView === view; button.classList.toggle('is-active', active); button.setAttribute('aria-pressed', active); });
    };
    const setConfig = (detail) => {
      config = { ...config, ...detail };
      root.querySelector('[data-acl-preview-config]').textContent = `${config.quantity} ${Number(config.quantity) === 1 ? 'curtain' : 'curtains'}`;
      root.querySelectorAll('[data-acl-preview-quantity]').forEach(button => {
        const active = Number(button.dataset.aclPreviewQuantity) === Number(config.quantity);
        button.classList.toggle('is-active', active);
        const small = button.querySelector('small');
        if (small) small.textContent = active ? 'Recommended' : '';
      });
    };
    window.addEventListener('allmerry:curtain-config', event => setConfig(event.detail));

    const accept = (file) => {
      if (!file || !/^image\//.test(file.type)) return;
      if (objectUrl) URL.revokeObjectURL(objectUrl);
      objectUrl = URL.createObjectURL(file);
      before.src = objectUrl; before.hidden = false;
      upload.hidden = true; preview.hidden = false; hasGenerated = false;
      setView('before');
      preview.scrollIntoView({ behavior: 'smooth', block: 'center' });
    };
    [fileInput, cameraInput].forEach(input => input?.addEventListener('change', () => accept(input.files?.[0])));
    root.querySelector('[data-acl-file-trigger]')?.addEventListener('click', event => { if (!event.target.closest('button')) fileInput.click(); });
    root.querySelector('.acl-upload__primary')?.addEventListener('click', event => { event.stopPropagation(); fileInput.click(); });
    root.querySelector('[data-acl-library-trigger]')?.addEventListener('click', () => fileInput.click());
    root.querySelector('[data-acl-camera-trigger]')?.addEventListener('click', () => cameraInput.click());
    root.querySelector('[data-acl-file-trigger]')?.addEventListener('keydown', event => { if (event.key === 'Enter' || event.key === ' ') fileInput.click(); });
    root.querySelector('[data-acl-generate]')?.addEventListener('click', buttonEvent => {
      const button = buttonEvent.currentTarget; button.disabled = true; button.textContent = 'Building your preview…';
      setTimeout(() => {
        hasGenerated = true; button.hidden = true;
        root.querySelector('[data-acl-preview-quantities]').hidden = false;
        root.querySelector('[data-acl-preview-status]').hidden = false;
        setView('lights');
      }, 900);
    });
    root.querySelectorAll('[data-acl-preview-view]').forEach(button => button.addEventListener('click', () => setView(button.dataset.aclPreviewView)));
    root.querySelectorAll('[data-acl-preview-quantity]').forEach(button => button.addEventListener('click', () => setConfig({ quantity: Number(button.dataset.aclPreviewQuantity) })));
    root.querySelector('[data-acl-start-over]')?.addEventListener('click', () => {
      upload.hidden = false; preview.hidden = true; hasGenerated = false; fileInput.value = ''; cameraInput.value = '';
      if (objectUrl) URL.revokeObjectURL(objectUrl); objectUrl = '';
    });
    setConfig(window.AllmerryCurtainConfig || config);
  }

  function initLibrary(root) {
    if (root.dataset.aclReady) return;
    root.dataset.aclReady = 'true';
    const cards = Array.from(root.querySelectorAll('[data-acl-design-card]'));
    root.querySelectorAll('[data-acl-library-filter]').forEach(button => button.addEventListener('click', () => {
      const filter = button.dataset.aclLibraryFilter;
      root.querySelectorAll('[data-acl-library-filter]').forEach(item => {
        const active = item === button;
        item.classList.toggle('is-active', active);
        item.setAttribute('aria-pressed', active);
      });
      cards.forEach((card, index) => {
        card.hidden = filter === 'favorites' ? index > 5 : card.dataset.category !== filter;
      });
      root.querySelector('[data-acl-design-rail]')?.scrollTo({ left: 0, behavior: 'smooth' });
    }));
  }

  function initControl(root) {
    if (root.dataset.aclReady) return;
    root.dataset.aclReady = 'true';
    const names = { colors: 'Color wheel', photos: 'Photos & GIFs', text: 'Text', animations: 'Animations', pixel: 'DIY Pixel Art', brightness: 'Brightness' };
    root.querySelectorAll('[data-acl-feature]').forEach(button => button.addEventListener('click', () => {
      root.querySelectorAll('[data-acl-feature]').forEach(item => item.classList.toggle('is-active', item === button));
      const title = root.querySelector('[data-acl-phone-title]');
      if (title) title.textContent = names[button.dataset.aclFeature] || 'Gallery';
    }));
  }

  function initInBox(root) {
    if (root.dataset.aclReady) return;
    root.dataset.aclReady = 'true';
    root.querySelectorAll('[data-acl-box-item]').forEach(button => button.addEventListener('click', () => {
      root.querySelectorAll('[data-acl-box-item]').forEach(item => item.classList.toggle('is-active', item === button));
    }));
  }

  function initFaq(root) {
    if (root.dataset.aclReady) return;
    root.dataset.aclReady = 'true';
    const recommendation = root.querySelector('[data-acl-faq-recommendation]');
    const apply = (config) => {
      if (recommendation && config) recommendation.textContent = `Your recommendation: ${config.quantity} ${Number(config.quantity) === 1 ? 'curtain' : 'curtains'}`;
    };
    apply(window.AllmerryCurtainConfig);
    window.addEventListener('allmerry:curtain-config', event => apply(event.detail));
    root.querySelector('[data-acl-faq-more]')?.addEventListener('click', buttonEvent => {
      const extra = root.querySelector('[data-acl-extra-faq]');
      extra.hidden = !extra.hidden;
      buttonEvent.currentTarget.classList.toggle('is-open', !extra.hidden);
      buttonEvent.currentTarget.firstChild.textContent = extra.hidden ? 'See all questions ' : 'Hide additional questions ';
    });
  }

  const init = (scope = document) => {
    scope.querySelectorAll('[data-acl-buy-box]').forEach(initBuyBox);
    scope.querySelectorAll('[data-acl-preview-section]').forEach(initPreview);
    scope.querySelectorAll('[data-acl-library]').forEach(initLibrary);
    scope.querySelectorAll('[data-acl-control]').forEach(initControl);
    scope.querySelectorAll('[data-acl-inbox]').forEach(initInBox);
    scope.querySelectorAll('[data-acl-faq]').forEach(initFaq);
  };
  init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
